import { createSlice } from "@reduxjs/toolkit";
import {
  fetchInvestments,
  addInvestment,
  updateInvestment,
  deleteInvestment,
} from "./investments.thunk";

const initialState = {
  investments: [],
  totalPages: 1,
  currentPage: 1,
  total: 0,
  limit: 10,
  loading: false,
  error: null,
  selectedInvestment: null,
};

const investmentsSlice = createSlice({
  name: "investments",
  initialState,

  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setSelectedInvestment: (state, action) => {
      state.selectedInvestment = action.payload;
    },
    clearSelectedInvestment: (state) => {
      state.selectedInvestment = null;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ===== FETCH ===== */
      .addCase(fetchInvestments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInvestments.fulfilled, (state, action) => {
        state.loading = false;
        state.investments = action.payload.data;
        state.totalPages = action.payload.meta.total_pages;
        state.total = action.payload.meta.total;
        state.limit = action.payload.meta.limit;
      })
      .addCase(fetchInvestments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ===== ADD ===== */
      .addCase(addInvestment.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(addInvestment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ===== UPDATE ===== */
      .addCase(updateInvestment.fulfilled, (state) => {
        state.loading = false;
      })

      /* ===== DELETE ===== */
      .addCase(deleteInvestment.fulfilled, (state, action) => {
        state.investments = state.investments.filter(
          (investment) => investment.id !== action.payload.id
        );
      });
  },
});

export const {
  setCurrentPage,
  setSelectedInvestment,
  clearSelectedInvestment,
} = investmentsSlice.actions;

export default investmentsSlice.reducer;